import { name as PWD } from './package.json';

const FOLDERS3 = 'brasil_servia';

const Defaults = {
  s3URL: `https://deoliyp60f2gq.cloudfront.net/${PWD}/${FOLDERS3}/`,
  qaURL: `https://infograficos-estaticos-dev.s3.amazonaws.com/${PWD}/${FOLDERS3}/`,
};

const Paths = {
  images: 'app/assets/img/**/*.{jpg,png,gif,svg}',
  styles: 'app/assets/sass/**/*.scss',
  scripts: ['app/assets/js/**/*.js', '!node_modules/**'],
  views: 'app/views/**/*.pug',
};

export { Defaults, Paths, FOLDERS3 };

